import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth, useIsJobCoach } from '@App/components/AuthProvider/auth-provider.context';
import { Button } from '@nazka/nazka.mapframe.components';
import {
  faBars, faCircleUser, faClose, faMessage,
} from '@fortawesome/pro-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import LoginModal from '@App/components/LoginModal/LoginModal';
import ContactModal from '@App/components/ContactModal/ContactModal';
import AccountMenu from '@App/components/AccountMenu/AccountMenu';
import CompanySearch from '@App/components/CompanySearch/CompanySearch';
import { setShowContactModal } from '@App/app.slice';
import { useLoginModal } from '@services/hooks.service';

import './nav.styl';

function Nav() {
  const dispatch = useDispatch();
  const searchGeometry = useSelector(state => state.map.searchGeometry);
  const currentRouteInfoPanelHeight = useSelector(state => state.map.currentRouteInfoPanelHeight);
  const showContactModal = useSelector(state => state.app.showContactModal);
  const [showAccountMenu, setShowAccountMenu] = useState();
  const [scrollPosition, setScrollPosition] = useState();
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
  const accountRef = useRef();
  const isJobCoach = useIsJobCoach();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    showLoginModal,
    setShowLoginModal,
    loginType,
    accountConfirmed,
  } = useLoginModal();

  const {
    isLoggedIn,
    loading,
    user,
  } = useAuth();

  useEffect(() => {
    const parentEl = document.querySelector('#js-mapframe > div:first-of-type');
    parentEl.addEventListener('scroll', () => {
      setScrollPosition(parentEl.scrollTop);
    });
  }, []);

  if ((loading || isLoggedIn) && !user) return null;

  return (
    <div className={`nav${scrollPosition > 0 ? ' nav--sticky' : ''}${mobileMenuIsOpen ? ' nav--mobile-menu-is-open' : ''}`}>
      <div
        className={`nav__logo${location.pathname !== '/' ? ' pointer' : ''}`}
        onClick={() => {
          if (location.pathname !== '/') {
            navigate('/');
          }
        }}
      >
        <img src="/img/logo/naarjobs.svg" alt="Logo - NaarJobs" className="nav__logo__img" />
      </div>
      {isJobCoach && searchGeometry && !['/', '/werkgever', '/jobcoach', '/meer-info'].includes(location.pathname) && (
        <CompanySearch />
      )}
      <div className="nav__items">
        {(location.pathname === '/meer-info') && (
          <div className="nav__items__item">
            <Button
              className="nav__items__item__button"
              onClick={() => navigate(-1)}
              icon={faArrowLeft}
            >
              Terug
            </Button>
          </div>
        )}
        {location.pathname !== '/meer-info' && (
          <div className="nav__items__item">
            <Button
              className="nav__items__item__button"
              onClick={() => navigate('/meer-info')}
            >
              Meer info
            </Button>
          </div>
        )}
        {!isLoggedIn && location.pathname !== '/werkgever' && (
          <div className="nav__items__item">
            <Button
              className="nav__items__item__button"
              onClick={() => {
                navigate('/werkgever');
              }}
            >
              Ik ben werkgever
            </Button>
          </div>
        )}
        {!isLoggedIn && location.pathname !== '/jobcoach' && (
          <div className="nav__items__item">
            <Button
              className="nav__items__item__button"
              onClick={() => {
                navigate('/jobcoach');
              }}
            >
              Ik ben jobcoach
            </Button>
          </div>
        )}
        {(isLoggedIn) && (
          <div className="nav__items__item nav__items__item--account" ref={accountRef}>
            <Button
              icon={isJobCoach ? '/img/icons/pro-user.svg' : faCircleUser}
              iconSize="30px"
              className="nav__items__item__button"
              onClick={() => {
                if (!isLoggedIn) setShowLoginModal(!showLoginModal);
                else if (!showAccountMenu) setShowAccountMenu(true);
              }}
            >
              {user?.family_name && (<span>{`${user?.given_name} ${user?.family_name}`}</span>)}
            </Button>
              {showAccountMenu && (
                <AccountMenu setShowAccountModal={setShowAccountMenu} accountRef={accountRef} />
              )}
          </div>
        )}
      </div>
      {showLoginModal && (
        <LoginModal
          type={loginType}
          setShowLoginModal={setShowLoginModal}
          accountConfirmed={accountConfirmed}
        />
      )}
      {showContactModal && (
        <ContactModal
          setShowContactModal={() => dispatch(setShowContactModal(!showContactModal))}
        />
      )}
      <Button
        className="nav__mobile-toggle"
        icon={mobileMenuIsOpen ? faClose : faBars}
        iconSize="25px"
        layout="ghost"
        hover={false}
        onClick={() => setMobileMenuIsOpen(!mobileMenuIsOpen)}
      />
      <Button
        className="nav__contact"
        onClick={() => dispatch(setShowContactModal(true))}
        themeColor="secondary"
        icon={faMessage}
        css={{
          transform: currentRouteInfoPanelHeight
            ? `translateY(-50%) translateY(-${currentRouteInfoPanelHeight}px) translateY(72px) rotate(-90deg) scale(0.9)`
            : 'translateY(-250%) rotate(-90deg) scale(0.9)',
        }}
      >
        Contact
      </Button>
    </div>
  );
}

export default Nav;